/**
 * @deprecated use JOB_POSITION_FRAGMENT
 */
export const jobPositionQueryFields = `
                id
                title
                slug
                active
                basicSalary
                salaryLow
                employmentTypes
                status
                fullTimeHours
                partTimeHours
                salaryHigh
                showSalary
                vacationDays
                canStartDate
                salaryElements {
                  daysPerMonth
                  id
                  percent
                  title
                }
                canStartNow
                geoLocation {
                  id
                  formattedAddress
                  placeId
                  location
                  postalCode
                  city
                  country
                }
                contractTypes {
                  id
                  title
                }
                whatADayLooksLike
                departments {
                  id
                  name
                }
                educationPayments {
                  id
                  title
                  value
                }
                jobTitles {
                  id
                  area
                  title
                  typeOfEmployer
                }
                employer {
                  id
                  status
                  aboutUs
                  averagePeriod
                  bestArgumentQuote
                  careType
                  name
                  showSalary
                  typesLeasingEmployer
                  sourceDomains
                  formalLanguage
                  averageTime
                  averagePeriod
                  adjustableDistance
                  offerApartments
                  interviewTypes
                  differentiations {
                    title
                    subtitle
                    id
                  }
                  displayContactPerson {
                    id
                    jobTitle
                  }
                  logoKey
                  contractSalesEmployeeId
                  createdAt
                  organisation {
                    logoKey
                  }
                  gallery
                  beds
                  teamSize
                  applicationProcess
                  numberOfDoctors
                  patients
                  overtimeCompensations {
                    title
                  }
                  salaryNegotiations {
                    title
                  }
                }
                beds
                teamSize
                applicationProcess
                numberOfDoctors
                isInitiative
                headline
                metaDescription
              `;
